import { Toaster } from '@zond/ui';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app/app';
import { setupDocumentHead } from './utils/branding';

setupDocumentHead();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <App />
    <Toaster position="top-right" />
  </StrictMode>
);
